/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

const handleSetDay = (value: string | null): boolean => {
  const convert = Number(value);
  if (convert >= 0 && convert <= 31) {
    return true;
  }
  return false;
};

const handleSetYear = (value: string | null): boolean => {
  const yearValue = new Date().getFullYear();
  const convert = Number(value);
  if (convert <= yearValue) {
    return true;
  }
  return false;
};

export { handleSetDay, handleSetYear };
